export default "__VITE_ASSET__BfHNVnax__"